import { SaveAlt } from '@mui/icons-material';
import { Box, Button } from '@mui/material';
import React from 'react';
import Swal from 'sweetalert2';
import { ProviderServices } from '../CrudServices';
import { formatDateTime } from '../../../utils/dateUtils';

const ExportAll = (props) => {
  const { paginationModel,profile } = props;

  // Define custom headers and their corresponding data mapping
  const exportMapping = [
    { 
      header: 'Provider Name',
      value: (row) => `${row.UserProfile?.firstName || ''} ${row.UserProfile?.middleName || ''} ${row.UserProfile?.lastName || ''} ${!row.UserProfile?.firstName ? 'Incomplete profile':''}`
    },
    {
      header: 'Mobile Number',
      value: (row) => row.mobileNumber || ''
    },
    {
      header: 'Email',
      value: (row) => row.UserProfile?.email || ''
    },
    {
      header: 'Gender',
      value: (row) => row.UserProfile?.gender || ''
    },
    {
      header: 'Categories',
      value: (row) => row.providerCat?.map(cat => cat.proServCat?.title).join(', ') || ''
    },
    {
      header: 'Status',
      value: (row) => row.isActive ? 'Active' : 'Inactive'
    },
    {
      header: 'KYC Status',
      value: (row) => row.isKycVerified ? 'Complete' : 'Incomplete'
    },
    {
      header: 'Address',
      value: (row) => row.userAllAddress?.[0]?.address || ''
    },
    {
      header: 'City',
      value: (row) => row.userAllAddress?.[0]?.city || ''
    },
    {
      header: 'State',
      value: (row) => row.userAllAddress?.[0]?.state || ''
    },
    {
      header: 'Registration Date',
      value: (row) => formatDateTime(row.createdAt)
    }
  ];

  const handleExportAllRows = async () => {
    try {
      Swal.fire({
        title: 'Exporting Data',
        text: 'Please wait while we prepare your download...',
        icon: 'info',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      const listResponse = await ProviderServices.providerListToExport({
        filters: {
          searchKey: paginationModel.filters.searchKey,
          sortBy: paginationModel.filters.sortBy,
          sortType: paginationModel.filters.sortType,
          filterOptions: paginationModel.filters.filterOptions || []
        }
      },profile);

      // Transform data using custom mapping
      const exportData = listResponse.data.list.map(row => {
        return exportMapping.reduce((acc, field) => {
          acc[field.header] = field.value(row);
          return acc;
        }, {});
      });

      // Create CSV content
      const headers = exportMapping.map(field => `"${field.header}"`).join(',');
      const csvContent = exportData.map(row => 
        exportMapping.map(field => 
          `"${String(row[field.header] ?? '').replace(/"/g, '""')}"`
        ).join(',')
      );

      csvContent.unshift(headers);

      // Create and download file
      const csvString = csvContent.join('\n');
      const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'ServiceExpert-report.csv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      Swal.fire({
        title: 'Export Successful',
        html: `
          <p>If download doesn't start automatically, click on provided link:
          <a href="${url}" download="ServiceExpert-report.csv" style="color: blue; text-decoration: underline;">
            Download CSV
          </a></p>
        `,
        icon: 'success',
        showConfirmButton: true,
        confirmButtonText: 'Close'
      });

    } catch (error) {
      console.error('Export failed', error);
      
      Swal.fire({
        title: 'Export Failed',
        text: 'There was an issue exporting the data. Please try again.',
        icon: 'error'
      });
    }
  };

  return (
    <Box>        
      <Button 
        onClick={handleExportAllRows}
        startIcon={<SaveAlt />}
        sx={{textTransform:'none'}}
      >
        Export
      </Button>      
    </Box>
  );
}

export default ExportAll;